module.exports = __webpack_public_path__ + "static/media/id-card-front.de1c5cba.png";